import {
	sessionStorageKeyAuthorizationToken,
	sessionStorageKeyIsRedirectedToG500Lite,
	sessionStorageKeyTokenIssuedDatetime,
} from '../const/commonConst';
import { removeSessionStorage } from './sessionStorageHandler';

/**
 * ログイン画面にリダイレクトする
 */
export const redirectToLogin = () => {
	removeSessionStorage(sessionStorageKeyAuthorizationToken);
	removeSessionStorage(sessionStorageKeyTokenIssuedDatetime);
	removeSessionStorage(sessionStorageKeyIsRedirectedToG500Lite);
	location.href = '/login';
};
